import gql from 'graphql-tag';

export const mutationViewIntegrationItemKind = gql`
  mutation viewIntegrationItemKind (
    $integrationItemKind: IntegrationItemKind!
  ) {
    viewIntegrationItemKind (
      integrationItemKind: $integrationItemKind
    )
  }
`;
export default mutationViewIntegrationItemKind;
